import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Placeholder from 'Components/Placeholder';
import FormSelect, { formOptions } from 'Components/FormSelect';

registerBlockType('eformv4/embed-form', {
	title: __('Embed Form - eForm', 'ipt_fsqm'),
	icon: 'feedback',
	category: 'eform-v4',
	attributes: {
		formId: {
			type: 'string',
			default: '',
		},
	},

	edit({ attributes, className, setAttributes }) {
		const { formId } = attributes;

		const onChangeId = selected =>
			setAttributes({ formId: selected.value });

		const selectedForm = formOptions.find(form => form.value === formId);

		const title =
			__('Embed Form : ', 'ipt_fsqm') +
			(selectedForm
				? selectedForm.label
				: __('Please select a form', 'ipt_fsqm'));
		const message = __('Embed eForm into content.', 'ipt_fsqm');

		return (
			<Placeholder className={className} title={title} message={message}>
				<FormSelect
					id="eform-gtb-embed-form-id"
					onChange={onChangeId}
					value={selectedForm}
				/>
			</Placeholder>
		);
	},

	save() {
		return null;
	},
});
